import React from 'react';
import { styled } from 'styled-components';
import THEME from '../theme.js';
const Note = (props) => {
    const { note } = props;
    const textParts = (note.notes || '').split('\n');
    return (React.createElement(NoteStyled, { style: props.style },
        React.createElement("div", { className: "body" }, textParts &&
            textParts.map((item, index) => (React.createElement(React.Fragment, { key: item + index },
                item,
                index !== textParts.length - 1 && React.createElement("br", null)))))));
};
export default Note;
const NoteStyled = styled.div `
  background: #fff;
  .from,
  .to,
  .body {
    border-bottom: 1px solid ${THEME.BORDER_STRONG};
    padding: 10px 15px;
  }
  .from > span:first-child,
  .to > span:first-child {
    width: 55px;
    opacity: 0.6;
    display: inline-block;
    text-align: right;
    margin-right: 10px;
    font-size: 0.75em;
  }
  .from > span:first-child:after,
  .to > span:first-child:after {
    content: ': ';
  }
  .body pre {
    overflow-wrap: break-word;
    word-break: break-word;
    white-space: pre-wrap;
  }
  .subject {
    font-weight: bold;
  }
  .date {
    float: right;
    color: ${THEME.TEXT_SUBTLE};
  }
  .email {
    padding: 20px;
  }
  border: 1px solid ${THEME.BORDER_STRONG};
  border-bottom: none;
`;
//# sourceMappingURL=Note.js.map